/* global axios */

import ApiClient from './ApiClient';

class AuditLogs extends ApiClient {
  constructor() {
    // Solvetia MIT: clean-room endpoint (account_audit_logs), no la ruta EE audit_logs.
    super('account_audit_logs', { accountScoped: true });
  }

  get({ page }) {
    const url = page ? `${this.url}?page=${page}` : this.url;
    return axios.get(url);
  }
}

export default new AuditLogs();
